import { useEffect, useState, useRef } from "react";
import axios from "axios";
import ImageZoom from "js-image-zoom";
import { useParams } from "react-router-dom";
import { useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Tooltip from '@mui/material/Tooltip';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';
import dayjs from 'dayjs'

//import MetaComponent from "../../components/MetaComponent";
import CartItemComponent from "../../../components/CartItemComponent";
import PaymentCard from './UserCartDetailsPaymentPart.js';

const config = require("../../../constants/constants.js")
const { strCurrency, strEuroCurrency } = require('../../../utils/currencyUtils.js')

const UserCartDetailsPageComponent = ({ cartItems, itemsCount, cartSubtotal, userInfo, addToCart, removeFromCart, reduxDispatch, getUser, createOrder }) => {

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [missingAddress, setMissingAddress] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("cc");

  const [shipping, setShipping] = useState("inclusa");
  const [tax, setTax] = useState("inclusa");

  const [nameSurname, setNameSurname] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCiy] = useState("");
  const [province, setProvince] = useState("");
  const [zip, setZip] = useState("");

  const [nameDb, setNameDb] = useState("");
  const [lastnameDb, setLastnameDb] = useState("");
  const [addressDb, setAddressDb] = useState("");
  const [zipCodeDb, setZipCodeDb] = useState("");
  const [countryDb, setCountryDb] = useState("");
  const [stateDb, setStateDb] = useState("");
  const [phoneDb, setPhoneDb] = useState("");
  const [emailDb, setEmailDb] = useState("");

  const [giornoAgenda, setGiornoAgenda] = useState("2025-03-06");
  const [colonna, setColonna] = useState("1");
  const [riga, setRiga] = useState("1");
  const [productPayName, setProductPayName] = useState("");
  const [productPayPrice, setProductPayPrice] = useState(0);
  const [productPayBookingprice, setProductPayBookingprice] = useState(0);
  const [productPayImage, setProductPayImage] = useState("");
  const [productPayCategory, setProductPayCategory] = useState("");
  const [productPayProduct, setProductPayProduct] = useState("");
  const [envVariable, setEnvVariable] = useState("");
  const [showAlertConfirmDelete, setShowAlertConfirmDelete] = useState(false);
  const [showAlertPagaPrenotazione, setShowAlertPagaPrenotazione] = useState(false);
  const [showAlertGraziePagamento, setShowAlertGraziePagamento] = useState(false);
  const [showAlertModificaIndirizzo, setShowAlertModificaIndirizzo] = useState(false);
  const [showAlertAppuntamentoPrenotato, setShowAlertAppuntamentoPrenotato] = useState(false);
  const [modalOpacity, setModalOpacity] = useState(0);
  const transitionTime = 300;
  const [paymentExecuted, setPaymentExecuted] = useState({});

  const url_background_paymentFrame = config.URL_IMAGES_CUSTOMER1 + "backpayframe.png";  // backpayframe.png 

  const [applicativo, setApplicativo] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");
  const [isApplicationWorkInProgress, setIsApplicationWorkInProgress] = useState("");
  const [showMainMenuUppercase, setShowMainMenuUppercase] = useState("");
  const [isBreadcrumbActive, setIsBreadcrumbActive] = useState("");
  
  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    //console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      //console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      setIsApplicationWorkInProgress(data?.isApplicationWorkInProgress);
      setShowMainMenuUppercase(data?.showMainMenuUppercase);
      setIsBreadcrumbActive(data?.isBreadcrumbActive);
      //console.log(`data?.applicativo =`, data?.applicativo);
      //console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      //console.log(`data?.linkFacebook =`, data?.linkFacebook);
      //console.log(`data?.linkInstagram =`, data?.linkInstagram);
      //console.log(`data?.linkTwitter =`, data?.linkTwitter);
      //console.log(`ragioneSociale =`, data?.ragioneSociale);
      //console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      //console.log(`isShopActive =`, data?.isShopActive);
      //console.log(`isIconLoginActive =`, data?.isIconLoginActive);
      //console.log(`isApplicationWorkInProgress =`, data?.isApplicationWorkInProgress);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [applicativo, isShopActive, showMainMenuUppercase])

  function chiudiModale() {
    // chiudi modale
  };

  const navigate = useNavigate();
  let pagamento = "";

  const changeCount = (productID, count) => {
    reduxDispatch(addToCart(productID, count));
  }

  const removeFromCartHandler = (productID, quantity, price) => {
    if (window.confirm("Sei sicuro?")) {
      reduxDispatch(removeFromCart(productID, quantity, price));
    }
  }

  const numItems = function (nItems) {
    return nItems === 1 ? nItems + " prodotto" : nItems + " prodotti"
  }

  const totaleItems = function (items) {
    let nrItems = 0;
    items.forEach(function (item, idx) {
      console.log(' item =', item)
      nrItems = nrItems + parseInt(item.quantity);

    })
    return nrItems === 1 ? nrItems + " prodotto" : nrItems + " prodotti"
  }

  useEffect(() => {
    getUser()
      .then((data) => {
        if (!data.address || !data.city || !data.country || !data.zipCode || !data.phoneNumber) {
          setButtonDisabled(true);
          setMissingAddress(" .In order to make order, fill out your profile with correct address, city etc.");
        } else {
          setNameSurname(userInfo.name + ' ' + userInfo.lastName);
          //setAddress(data.address + ', ' + data.zipCode + ' ' + data.city + ' (' + data.country + ')');
          setAddress(data.address);
          setPhone(data.phoneNumber);
          setZip(data.zipCode);
          setCiy(data.city);
          setProvince(data.country);

          setNameDb(userInfo.name);
          setLastnameDb(userInfo.lastName);
          setAddressDb(data.address);
          setZipCodeDb(data.zipCode);
          setCountryDb(data.country);
          setStateDb(data.state);
          setPhoneDb(data.phoneNumber);
        }
      })
      .catch((er) => console.log(er.response.data.message ? er.response.data.message : er.response.data));
  }, [userInfo._id])

  const createOrderOnDb = () => {

    console.log('[createOrderOnDb]')
    console.log('[createOrderOnDb] paymentExecuted =', paymentExecuted)

    const orderData = {
      orderTotal: {
        itemsCount: itemsCount,
        cartSubtotal: cartSubtotal,
      },
      cartItems: cartItems.map(item => {
        return {
          productID: item.productID,
          name: item.name,
          price: item.price,
          image: { path: item.image ? (item.image.path ?? null) : null },
          quantity: item.quantity,
          count: item.count,
        }
      }),
      isPaid: true,
      paymentMethod: paymentMethod,
      transactionResult: {
        status: "paid",
        createTime: paymentExecuted.date + " " + paymentExecuted.hour,
        amount: paymentExecuted.amount,
        email: paymentExecuted.email,
      },
      shippingAddress: {
        nameSurname: nameSurname,
        address: address,
        phone: phone,
        zip: zip,
        city: city,
        province: province,
        description: "",
        note: "",
      },
    }

    createOrder(orderData);
  }

  const choosePayment = (e) => {
    setPaymentMethod(e.target.value);
    pagamento = e.target.value;
  }

  function resetCarrello() {
    //    cartItems=0;
    //    itemsCount=0;
    //    cartSubtotal=0;    
    console.log('[resetCarrello] cartItems =', cartItems)
    {
      cartItems.map((item, idx) => (
        reduxDispatch(removeFromCart(item, idx, idx))
      ))
    }
    console.log('[resetCarrello] dopo reset cartItems =', cartItems)
  }

  return (


    <Box sx={{ flexGrow: 1 }}>

      <Box
        display={isBreadcrumbActive === 'Si' ? "block" : "none"}
      >
        <Breadcrumbs separator="›" aria-label="breadcrumb"
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 1, md: 1 }}
          paddingBottom={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 2, md: 6 }}
          paddingRight={{ xs: 1, md: 8 }}
          spacing={{ xs: 2, md: 2 }}
        >
          <Link underline="hover" color="inherit" href="/">
            <Typography
              sx={{
                color: 'text.primary',
                fontFamily: 'Roboto',
                textTransform: 'none',
                fontSize: 14,
              }}
            >
              {config.BC_HOME}
            </Typography>
          </Link>
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'Roboto',
              textTransform: 'none',
              fontSize: 14,
            }}
          >
            {config.BC_CHECKOUT}
          </Typography>
        </Breadcrumbs>
      </Box>

    {/* 

      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 0, md: 0 }}
        paddingLeft={{ xs: 2, md: 6 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          {config.BC_HOME}
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/prodotti"
        >
          {config.BC_CHECKOUT}
        </Link>
      </Breadcrumbs>
    */}

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

      <Grid container spacing={{ xs: 4, md: 6 }}>

        <Grid
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 6 }}
        >

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6',
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Typography variant="h5" color='#1136a0'
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                p: 1, m: 0,
              }}
            >
              Spedizione
            </Typography>

            <Box display={!showAlertModificaIndirizzo ? "block" : "none"}
              // confermo indirizzo
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
              }}
            >

              <Box
                sx={{ '& > :not(style)': { m: 1, width: '50ch' } }}
                noValidate
                autoComplete="off"
              >

                <TextField id="id-nome" label="Cognome e nome" variant="outlined" value={nameSurname}
                  size="small"
                  slotProps={{
                    inputLabel: { shrink: true },
                    input: { readOnly: true },
                  }}
                  onChange={(event) => {
                    //setNameSurname(event.target.value);
                  }}
                />

                <TextField id="id-indirizzo" label="Indirizzo" variant="outlined" value={address}
                  size="small"
                  slotProps={{
                    inputLabel: { shrink: true },
                    input: { readOnly: true },
                  }}
                  onChange={(event) => {
                    //setAddress(event.target.value);
                  }}
                />

                <Grid
                  container
                  spacing={1}
                  paddingTop={{ xs: 0, md: 0 }}
                  paddingLeft={{ xs: 0, md: 0 }}
                >

                  <Grid
                    size={{ xs: 12, md: 6 }}
                    paddingTop={{ xs: 0, md: 0 }}
                    paddingLeft={{ xs: 0, md: 0 }}
                    sx={{ '& > :not(style)': { marginBottom: 2 } }}
                  >

                    <TextField id="id-telefono" label="Telefono" variant="outlined" value={phone}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                        input: { readOnly: true },
                      }}
                      onChange={(event) => {
                        //setPhone(event.target.value);
                      }}
                    />

                    <TextField id="id-citta" label="Città" variant="outlined" value={city}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                        input: { readOnly: true },
                      }}
                      onChange={(event) => {
                        //setPhone(event.target.value);
                      }}
                    />

                  </Grid>

                  <Grid
                    size={{ xs: 12, md: 6 }}
                    paddingTop={{ xs: 0, md: 0 }}
                    paddingLeft={{ xs: 0, md: 0 }}
                    sx={{ '& > :not(style)': { marginBottom: 2 } }}
                  >

                    <TextField id="id-cap" label="Cap" variant="outlined" value={zip}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                        input: { readOnly: true },
                      }}
                      onChange={(event) => {
                        //setPhone(event.target.value);
                      }}
                    />

                    <TextField id="id-provincia" label="Provincia" variant="outlined" value={province}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                        input: { readOnly: true },
                      }}
                      onChange={(event) => {
                        //setPhone(event.target.value);
                      }}
                    />

                  </Grid>
                </Grid>

              </Box>

              <Button
                disabled={buttonDisabled}
                type="button"
                variant="contained"
                color="success"
                size="small"
                onClick={(e) => {
                  setShowAlertModificaIndirizzo(true);
                }}
              >
                Modifica indirizzo
              </Button>

            </Box>

            <Box display={showAlertModificaIndirizzo ? "block" : "none"}
              // modifico indirizzo
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
              }}
            >

              <Box
                sx={{ '& > :not(style)': { m: 1, width: '50ch' } }}
                noValidate
                autoComplete="off"
              >

                <Grid
                  container
                  spacing={1}
                  paddingTop={{ xs: 0, md: 0 }}
                  paddingLeft={{ xs: 0, md: 0 }}
                >

                  <Grid
                    size={{ xs: 12, md: 6 }}
                    paddingTop={{ xs: 0, md: 0 }}
                    paddingLeft={{ xs: 0, md: 0 }}
                    sx={{ '& > :not(style)': { marginBottom: 0 } }}
                  >

                    <TextField id="id-nome" label="Nome" variant="outlined" value={nameDb}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      onChange={(event) => {
                        setName(event.target.value);
                      }}
                    />

                  </Grid>

                  <Grid
                    size={{ xs: 12, md: 6 }}
                    paddingTop={{ xs: 0, md: 0 }}
                    paddingLeft={{ xs: 0, md: 0 }}
                    sx={{ '& > :not(style)': { marginBottom: 0 } }}
                  >

                    <TextField id="id-cognome" label="Cognome" variant="outlined" value={lastnameDb}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      onChange={(event) => {
                        setSurname(event.target.value);
                      }}
                    />

                  </Grid>
                </Grid>

                <TextField id="id-indirizzo" label="Indirizzo" variant="outlined" value={addressDb}
                  size="small"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  onChange={(event) => {
                    setAddress(event.target.value);
                  }}
                />

                <Grid
                  container
                  spacing={1}
                  paddingTop={{ xs: 0, md: 0 }}
                  paddingLeft={{ xs: 0, md: 0 }}
                >

                  <Grid
                    size={{ xs: 12, md: 6 }}
                    paddingTop={{ xs: 0, md: 0 }}
                    paddingLeft={{ xs: 0, md: 0 }}
                    sx={{ '& > :not(style)': { marginBottom: 2 } }}
                  >

                    <TextField id="id-telefono" label="Telefono" variant="outlined" value={phoneDb}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      onChange={(event) => {
                        setPhone(event.target.value);
                      }}
                    />

                    <TextField id="id-citta" label="Citta" variant="outlined" value={countryDb}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      onChange={(event) => {
                        setAddress(event.target.value);
                      }}
                    />

                  </Grid>

                  <Grid
                    size={{ xs: 12, md: 6 }}
                    paddingTop={{ xs: 0, md: 0 }}
                    paddingLeft={{ xs: 0, md: 0 }}
                    sx={{ '& > :not(style)': { marginBottom: 2 } }}
                  >

                    <TextField id="id-cap" label="Cap" variant="outlined" value={zipCodeDb}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      onChange={(event) => {
                        setAddress(event.target.value);
                      }}
                    />

                    <TextField id="id-provincia" label="Provincia" variant="outlined" value={province}
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                        input: { readOnly: true },
                      }}
                      onChange={(event) => {
                        //setPhone(event.target.value);
                      }}
                    />


                  </Grid>

                </Grid>


              </Box>

              <Button
                disabled={buttonDisabled}
                type="button"
                variant="contained"
                color="success"
                size="small"
                onClick={(e) => {
                  setShowAlertModificaIndirizzo(false);
                }}
              >
                Salva indirizzo
              </Button>

            </Box>

          </Paper>

        </Grid>

        <Grid
          size={{ xs: 12, md: 3 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 0 }}
        >

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6',
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Typography variant="h5" color='#1136a0'
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                p: 1, m: 0,
              }}
            >
              Riepilogo ordine
            </Typography>

            <Grid
              container
              spacing={1}
              paddingTop={{ xs: 0, md: 0 }}
              paddingLeft={{ xs: 0, md: 2 }}
            >

              <Grid
                size={{ xs: 12, md: 6 }}
                paddingTop={{ xs: 0, md: 0 }}
                paddingLeft={{ xs: 0, md: 0 }}
              >

                <Box
                  // colonna centrale Prezzi
                  sx={{ '& > :not(style)': { m: 1, width: '15ch' } }}
                  noValidate
                  autoComplete="off"
                >

                  <TextField id="id-price" label="Prezzo articoli" variant="outlined" value={strEuroCurrency(cartSubtotal)}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                  <TextField id="id-tax" label="iva" variant="outlined" value={tax}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                  <TextField id="id-totalPrice" label="Prezzo totale" value={strEuroCurrency(cartSubtotal)}
                    size="small"
                    variant="filled"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                    sx={{
                      "& .MuiFilledInput-root": {
                        color: "#000",
                        fontFamily: "Arial",
                        fontWeight: "bold",
                        backgroundColor: "#f4f4f4",
                        borderTopLeftRadius: "7px",
                        borderTopRightRadius: "7px",
                      },
                      "& .MuiInputLabel-filled": {
                        color: "#2e2e2e",
                        fontWeight: "bold",
                      },
                    }}
                  />

                </Box>
              </Grid>

              <Grid
                // colonna centrale Prezzi
                size={{ xs: 12, md: 6 }}
                paddingTop={{ xs: 0, md: 0 }}
                paddingLeft={{ xs: 0, md: 1 }}
              >

                <Box
                  sx={{ '& > :not(style)': { m: 1, width: '15ch' } }}
                  noValidate
                  autoComplete="off"
                >

                  <TextField id="id-products" label="nr articoli" variant="outlined" value={totaleItems(cartItems)}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                  <TextField id="id-shipping" label="spedizione" variant="outlined" value={shipping}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                </Box>

              </Grid>

              <Button
                disabled={buttonDisabled}
                type="button"
                variant="contained"
                color="success"
                size="small"
                onClick={(e) => {
                  setGiornoAgenda('03/04/2025');
                  setProductPayName('Nr. ' + totaleItems(cartItems));
                  setProductPayPrice(cartSubtotal);
                  setProductPayBookingprice(cartSubtotal);
                  setProductPayImage(url_background_paymentFrame);
                  setProductPayCategory('');
                  //createOrderOnDb();
                  setShowAlertPagaPrenotazione(true);
                }}
              >
                Paga con Carta
              </Button>

            </Grid>
          </Paper>

        </Grid>

        <Grid
          size={{ xs: 12, md: 3 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 0 }}
          display={showAlertPagaPrenotazione ? "block" : "none"}
        >

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6',
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Box
              sx={{ '& > :not(style)': { marginLeft: 0, width: '25ch' } }}
              noValidate
              autoComplete="off"
            >

              <Typography variant="h5" color='#1136a0'
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  p: 1, m: 0,
                }}
              >
                Acquisto carta di credito
              </Typography>

              <Grid
                size={{ xs: 12, md: 12 }}
                paddingTop={{ xs: 0, md: 0 }}
                paddingLeft={{ xs: 0, md: 0 }}
                className="justify-content-right"
              >
                <div className="mt-3 mb-3 container d-flex justify-content-center flex-wrap">
                  {
                    <PaymentCard datiGiornoAgenda={giornoAgenda} indexResource={colonna.toString()} indexHour={riga.toString()}
                      productName={productPayName} price={productPayPrice} productBookingPrice={productPayBookingprice} productImage={productPayImage} productProduct={productPayProduct} productCategory={productPayCategory}
                      envVariable={envVariable}
                      setShowAlertPagaPrenotazione={setShowAlertPagaPrenotazione}
                      setShowAlertGraziePagamento={setShowAlertGraziePagamento}
                      setPaymentExecuted={setPaymentExecuted} />
                  }
                </div>
              </Grid>
            </Box>

            <Dialog open={showAlertGraziePagamento}>
              <Alert
                sx={{ background: "#a7d6f6ff" }}
                onClose={() => {
                  setShowAlertGraziePagamento(false);
                  console.log('[createOrderOnDb] #1')
                  createOrderOnDb();
                  console.log('[createOrderOnDb] #2')
                  resetCarrello();
                  cartItems = {};
                  //navigate("/");
                  navigate(0);
                }}
              >

                <Grid
                  size={{ xs: 12, md: 12 }}
                  paddingTop={{ xs: 0, md: 0 }}
                  paddingLeft={{ xs: 0, md: 0 }}
                  className="justify-content-right"
                >
                  <Typography sx={{ color: '#1136a0', fontSize: 24 }}>
                    Ordine fatto
                  </Typography>
                  <Typography sx={{ color: '#1136a0', fontSize: 8 }}>
                    &nbsp;
                  </Typography>
                  <Typography sx={{ color: '#1136a0', fontSize: 14 }}>
                    <li>inviata email di conferma d'ordine</li>
                    <li>riceverai la merce entro 72 ore</li>
                  </Typography>
                  <Typography sx={{ color: '#1136a0', fontSize: 8 }}>
                    &nbsp;
                  </Typography>
                  <Typography sx={{ color: '#1136a0', fontSize: 14 }}>
                    Grazie per il pagamento
                  </Typography>
                </Grid>
              </Alert>
            </Dialog>

          </Paper>

        </Grid>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

      <Grid
        size={{ xs: 12, md: 10 }}
        paddingTop={{ xs: 0, md: 0 }}
        paddingLeft={{ xs: 0, md: 6 }}
        paddingRight={{ xs: 0, md: 10 }}
      >
        <Paper
          sx={{
            paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
            background: '#cce0e6',
            background: '#bfdae3ff',
          }}
          elevation={6}
        >

          <Typography variant="h5" color='#1136a0'
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              p: 1, m: 0,
            }}
          >
            Prodotti
          </Typography>

          <List variant="flush">
            {cartItems.map((item, idx) => (
              <CartItemComponent item={item} key={idx} removeFromCartHandler={removeFromCartHandler} changeCount={changeCount} />
            ))}
          </List>

        </Paper>

        <Box
          sx={{
            paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
            height: 40
          }}
        />

      </Grid>

    </Box >);
};

export default UserCartDetailsPageComponent;
